import React from 'react'
import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useHeadlessParticipant } from '../../../../webrtc/webRTCRoom'

import './FloorHeadlessFeed.scss'

interface FloorHeadlessFeedProps {
  isVisible: boolean
}

const FloorHeadlessFeed = ({ isVisible }: FloorHeadlessFeedProps) => {
  const headlessParticipant = useHeadlessParticipant()

  if (!headlessParticipant?.tracks.screen) return null

  return (
    <div className="floor-headless-feed" style={{ opacity: isVisible ? 1 : 0 }}>
      <VideoTrack
        track={headlessParticipant.tracks.screen}
        objectFit="contain"
      />
    </div>
  )
}

export { FloorHeadlessFeed }
